/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('data.employee').factory('EmployeeApprovedClient', ['AppModel', function(AppModel) {

  class EmployeeApprovedClient extends AppModel {
    static initClass() {
      this.configure({url : '/employees/{{employeeId}}/approved_clients', name : 'approved_client'});
    }
  }

  EmployeeApprovedClient.initClass();
  return EmployeeApprovedClient;
}
]);